// Barrel para consolidar a API em um único objeto
import * as auth from "./auth";
import * as clients from "./clients";
import * as appointments from "./appointments";
import * as employees from "./employees";
import * as company from "./company";
import * as payments from "./payments";

import * as specialties from "./specialties";
import * as schedule from "./schedule";
import * as recurring from "./recurring";
import * as metrics from "./metrics";
import * as blog from "./blog";
import * as pricing from "./pricing";
import * as whatsapp from "./whatsapp";
import * as insurance from "./insurance";

// NOTE: touching this file forces HMR to rebuild the aggregated API object
// Updated to include latest WhatsApp helpers
export const api = {
  // Auth
  ...auth,
  // Clients
  ...clients,
  // Appointments
  ...appointments,
  // Employees / Professionals
  ...employees,
  // Specialties
  ...specialties,
  // Company
  ...company,

  // Payments
  ...payments,
  // Schedule
  ...schedule,
// Recurring appointments (mensalista)
  ...recurring,
  // Metrics
  ...metrics,
  // Blog
  ...blog,
  // Pricing
    ...pricing,
    // WhatsApp settings
    ...whatsapp,
  // Insurance
    ...insurance,
  };

export type { ApiResponse } from "./http";
